import { useState, useEffect, useCallback } from 'react';

const MAX_POINTS = 20;
const STORAGE_KEY = 'coordinates_history';

export const useCoordinatesHistory = () => {
  const [recentCoordinates, setRecentCoordinates] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error loading coordinates history:', error);
      return [];
    }
  });

  // Memoize addCoordinate to prevent recreation on each render
  const addCoordinate = useCallback((newCoord) => {
    if (!newCoord?.lat || !newCoord?.lng) return;
    
    setRecentCoordinates(prev => {
      // Skip if the new coordinate is identical to the most recent one
      if (prev.length > 0 && 
          prev[0].lat === newCoord.lat && 
          prev[0].lng === newCoord.lng) {
        return prev;
      }
      
      const updated = [newCoord, ...prev].slice(0, MAX_POINTS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  // Memoize clearHistory to prevent recreation on each render
  const clearHistory = useCallback(() => {
    setRecentCoordinates([]);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return { recentCoordinates, addCoordinate, clearHistory };
};